<template lang="pug">
  component(:is="getComponent(item)" :item="item" :type="type")
</template>

<script>
import NotificationAccountBlocked from '@/components/notification/NotificationAccountBlocked.vue';
import NotificationAccountLowBalance from '@/components/notification/NotificationAccountLowBalance.vue';
import NotificationAccountWillBeDeleted from '@/components/notification/NotificationAccountWillBeDeleted.vue';
import NotificationAgreementAnswer from '@/components/notification/NotificationAgreementAnswer.vue';
import NotificationBecomeProjectMember from '@/components/notification/NotificationBecomeProjectMember.vue';
import NotificationCommentPublish from '@/components/notification/NotificationCommentPublish.vue';
import NotificationCommentUpdate from '@/components/notification/NotificationCommentUpdate.vue';
import NotificationContactRequestAccepted from '@/components/notification/NotificationContactRequestAccepted.vue';
import NotificationContactRequestCreated from '@/components/notification/NotificationContactRequestCreated.vue';
import NotificationContactRequestDeclined from '@/components/notification/NotificationContactRequestDeclined.vue';
import NotificationTaskExpires from '@/components/notification/NotificationTaskExpires.vue';
import NotificationTaskPublish from '@/components/notification/NotificationTaskPublish.vue';
import NotificationTaskReminder from '@/components/notification/NotificationTaskReminder.vue';
import NotificationTaskUpdate from '@/components/notification/NotificationTaskUpdate.vue';
import NotificationCompanyBecomeDeputy from '@/components/notification/NotificationCompanyBecomeDeputy.vue';
import NotificationCompanyUnbecomeDeputy from '@/components/notification/NotificationCompanyUnbecomeDeputy.vue';
import NotificationCompanyEmployeeCreated from '@/components/notification/NotificationCompanyEmployeeCreated.vue';
import NotificationCompanyEmployeeDeleted from '@/components/notification/NotificationCompanyEmployeeDeleted.vue';
import NotificationCompanyDepartmentMemberCreated from '@/components/notification/NotificationCompanyDepartmentMemberCreated.vue';
import NotificationCompanyDepartmentMemberDeleted from '@/components/notification/NotificationCompanyDepartmentMemberDeleted.vue';
import NotificationCompanyDepartmentMemberRoleUpdated from '@/components/notification/NotificationCompanyDepartmentMemberRoleUpdated.vue';
import NotificationCrmClientBirthday from '@/components/notification/NotificationCrmClientBirthday.vue';
import NotificationCrmLeadReminder from '@/components/notification/NotificationCrmLeadReminder.vue';
import NotificationCrmLeadCommentPublish from '@/components/notification/NotificationCrmLeadCommentPublish.vue';

export default {
  name: 'NotificationComponentSelector',
  components: {
    NotificationAccountBlocked,
    NotificationAccountLowBalance,
    NotificationAccountWillBeDeleted,
    NotificationBecomeProjectMember,
    NotificationCommentPublish,
    NotificationCommentUpdate,
    NotificationTaskPublish,
    NotificationTaskUpdate,
    NotificationTaskExpires,
    NotificationTaskReminder,
    NotificationContactRequestCreated,
    NotificationContactRequestAccepted,
    NotificationContactRequestDeclined,
    NotificationAgreementAnswer,
    NotificationCompanyBecomeDeputy,
    NotificationCompanyUnbecomeDeputy,
    NotificationCompanyEmployeeCreated,
    NotificationCompanyEmployeeDeleted,
    NotificationCompanyDepartmentMemberCreated,
    NotificationCompanyDepartmentMemberDeleted,
    NotificationCompanyDepartmentMemberRoleUpdated,
    NotificationCrmClientBirthday,
    NotificationCrmLeadReminder,
    NotificationCrmLeadCommentPublish,
  },
  props: {
    item: Object,
    type: String,
  },
  methods: {
    getComponent(notification) {
      const isTaskUpdate = notification.type === 'task-closure'
        || notification.type === 'task-checklist-check'
        || notification.type === 'task-checklist-change'
        || notification.type.startsWith('task-update-')
        || notification.type.startsWith('become-task-');

      if (isTaskUpdate) {
        return 'NotificationTaskUpdate';
      }

      if (notification.type.startsWith('task-expires')) {
        return 'NotificationTaskExpires';
      }

      const type = notification.type
        .split('-')
        .map((w) => w.charAt(0).toUpperCase() + w.substring(1))
        .join('');
      return `Notification${type}`;
    },
  },
};
</script>

<style scoped>

</style>
